module.exports = __webpack_public_path__ + "static/media/Bodies.79f8293c.mp3";